/**************
 Desktop Nav
 ***************/

// nested menu dropdown
document.querySelectorAll(".headerNavLinkButton").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// clicking outside of menu closes menu
document.addEventListener("click", function (e) {
    const button = document.querySelector(".headerNavLinkButton.active");
    if (button && !button.contains(e.target)) {
        button.classList.remove("active");
    }
});

/**************
 Mobile Nav
 ***************/

// open mobile nav hamburger
document.querySelector('#headerMenu').addEventListener("click", () => {
    // switch hamburger to x
    document.querySelector('#header').classList.add('active');

    // show mobile nav
    document.querySelector("#headerMobileNav").classList.add("active");

    // hide all nested navs
    document.querySelectorAll('#headerMobileExtendedNav .headerMobileExtendedNavMenu').forEach(el => el.classList.remove('active'));
});

// close nav x
document.querySelector("#headerClose").addEventListener("click", () => {
    // switch x to hamburger
    document.querySelector('#header').classList.remove('active');

    // hide mobile nav
    document.querySelector("#headerMobileNav").classList.remove("active");

    // hide all nested navs
    document.querySelectorAll('#headerMobileExtendedNav .headerMobileExtendedNavMenu').forEach(el => el.classList.remove('active'));
});

// opens nested submenu
document.querySelectorAll('.headerMobileNavLinkToggle').forEach(el => {
    el.addEventListener('click', function () {
        // hide mobile nav
        document.querySelector("#headerMobileNav").classList.remove("active");

        // show nested submenu
        document.querySelector(`.headerMobileExtendedNavMenu[data-title="${this.dataset.title}"]`).classList.add('active');
    })
})

// closes nested submenu
document.querySelectorAll('.headerMobileExtendedNavMenuTitle').forEach(el => {
    el.addEventListener('click', function () {
        // show mobile nav
        document.querySelector("#headerMobileNav").classList.add("active");

        // hide nested submenu
        let dataTitle = this.closest('.headerMobileExtendedNavMenu').dataset.title;
        document.querySelector(`.headerMobileExtendedNavMenu[data-title="${dataTitle}"]`).classList.remove('active');
    })
})